import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ISampleVideoComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleVideoComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import UploadComponent from '@components/UploadComponent';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Row } from 'antd';
import React from 'react';

import { InstructionTaskComponent } from '../TextInstructionComponent';


interface ISampleVideoTaskComponentStateType {
  modelComponent: ISampleVideoComponent;
  instructionTitle: string;
  description?: string;
  modelValidator: string;
  imageFileList: any[];
  imageUpload: any;
  modelValidatorType: boolean | null;
  fileList: any;
  response: string;
  isLoadingFile: boolean;
};

export class SampleVideoComponent implements ISampleVideoComponent {
  id: string;
  type: ComponentType;
  title: string;
  description?: string;
  url: string;
  constructor(id: string = '') {
    this.id = id;
    this.type = ComponentType.SAMPLEVIDEO;
    this.title = '';
    this.url = '';
    return this;
  }
}

export default class SampleVideoTaskComponent extends React.Component<ISampleVideoComponent, ISampleVideoTaskComponentStateType> {

  constructor(props: ISampleVideoComponent) {
    super(props);
    this.onModalImageChanged = this.onModalImageChanged.bind(this);
    this.setImageValidator = this.setImageValidator.bind(this);
    this.formatImageList = this.formatImageList.bind(this);
    this.state = {
      instructionTitle: this.props.title || '',
      description: this.props.description || undefined,
      modelComponent: {
        id: this.props.id,
        type: ComponentType.SAMPLEVIDEO,
        title: this.props.title,
        description: this.props.description,
        url: this.props.url,
      },
      modelValidator: '',
      imageFileList: [],
      imageUpload: '',
      modelValidatorType: null,
      fileList: '',
      response: '',
      isLoadingFile: false
    };
  }

  UNSAFE_componentWillMount() {
    this.initialData()
  }

  initialData = async () => {
    await this.formatImageList()
    this.setState({ imageUpload: this.props.url !== undefined ? this.props.url : '' })
  }

  //#region HANDLERS
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }
  setImageValidator(modelValidator: Function) {
    // this.setState({ modelValidator })
  }
  onModalImageChanged = async (imageData: any) => {
    this.setState({ imageUpload: imageData });
  }
  validateType = async (validateExtension: any) => {
    this.setState({ modelValidatorType: validateExtension })
    console.log('valor aaaaa', validateExtension)
  }
  validateUploadModel = async (fileList: any) => {
    this.setState({ fileList })
  }

  isLoadingFile = async (isLoading: any) => {
    this.setState({ isLoadingFile: isLoading })
  }

  formatImageList = async () => {
    let modelList: any[] = [];
    if (this.props.url !== '') {
      modelList.push({
        uid: '1',
        name: I18n.l('formflow.components.download') /*product.name || 'image.jpg'*/,
        url: this.props.url,
        thumbUrl: this.props.url,
        status: 'done'
      });
      this.setState({ imageFileList: modelList })
    }

  }
  onRemoveModalImage = async () => {
    this.setState({ imageUpload: '' })
  }
  //#endregion

  onSubmitModelComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    const newModelDataComponent: ISampleVideoComponent = {
      id: this.props.id,
      type: ComponentType.SAMPLEVIDEO,
      title: this.state.instructionTitle,
      description: this.state.description,
      url: this.state.imageUpload
    }
    updateFormflowWithComponent(newModelDataComponent);
  }

  onChange(e: any) {



  }

  render() {
    const {
      instructionTitle,
    } = this.state

    return (
      <div>
        <InstructionTaskComponent
          conditionsTaskComponents={false}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          visibleDescription={true}
          inputTitleValue={instructionTitle}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          titleComponent={I18n.l("formflow.components.sampleVideo.titleSampleVideoComponent")}
          descriptionComponent={I18n.l("formflow.components.sampleVideo.descriptionSampleVideoComponent")}
          exampleDescriptionComponent={I18n.l("formflow.components.sampleVideo.exampleDescriptionSampleVideoComponent")}
        />
        <Wrapper>
          <div
            style={{ marginTop: '3rem', marginBottom: '0.5rem' }}
          >
            <div className='alert-message'> {I18n.l('formflow.labels.sampleVideo.alertSize')}</div>
            <div> {I18n.l('formflow.labels.sampleVideo.insertVideo')}</div>
          </div>
          <UploadComponent
            accept={'.mp4'}
            isStorage={true}
            onValidate={this.setImageValidator}
            buttonTitle={I18n.l('form.labels.alerts.image')}
            customListType={'picture'}
            defaultFileList={this.state.imageFileList}
            onFileListChange={this.onModalImageChanged}
            onRemoveImage={this.onRemoveModalImage}
            validateUpload={this.validateUploadModel}
            isLoadingFile={this.isLoadingFile}
          />
        </Wrapper>

        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button
                    className="button-save"
                    type="primary"
                    disabled={instructionTitle.length === 0 ||
                      instructionTitle.length < 3 ||
                      this.state.imageUpload === '' ||
                      this.state.isLoadingFile
                      ? true : false
                    }
                    onClick={() => { this.onSubmitModelComponent(updateFormflowWithComponent) }} >
                    {I18n.l('common.save')}
                  </Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </div>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
  margin-left: 3rem;
  .ant-upload {
    width: 50%;
}
.alert-message{
  color: ${Theme.secondary.midGrey};
  font-weight: bold;
  padding-bottom: 1rem;
}
`;

const ButtonStyle = styled.div`
    float:right;
    margin-top: 15vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
//#endregion
